import React, { useState, useEffect, useMemo } from "react";
import { Table } from "react-bootstrap";
import { getGastos, deleteGasto, getGastoById } from "../helpers/rutaGastos";
import ModalGasto from "./ModalGasto";
import "../css/tableclientes.css";

const TableGastos = () => {
  const [gastos, setGastos] = useState({
    data: {},
    loading: true,
  });

  const [gasto, setGasto] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaGastos();
  }, []);

  const consultaGastos = () => {
    getGastos().then((datos) => {
      console.log("📦 Gastos:", datos);
      setGastos({
        data: datos,
        loading: false,
      });
    });
  };

  const handleClose = () => {
    setShow(false);
    consultaGastos();
  };

  const handleShow = () => setShow(true);

  const modificaGasto = (id) => {
    getGastoById(id).then((resp) => {
      if (resp.ok) {
        setGasto(resp.gasto);
        handleShow();
      } else {
        console.error("❌ Error al obtener gasto:", resp.error);
      }
    });
  };

  const eliminarGasto = (id) => {
    const confirmar = window.confirm("¿Está seguro que desea borrar el gasto?");
    if (confirmar) {
      deleteGasto(id).then(() => consultaGastos());
    }
  };

  // ✅ Orden: Cuenta (alfabético) -> Gasto (alfabético)
  const listaOrdenada = useMemo(() => {
    const arr = Array.isArray(gastos?.data?.gastos) ? [...gastos.data.gastos] : [];

    const norm = (s) => String(s || "").trim().toLowerCase();

    arr.sort((a, b) => {
      const ca = norm(a?.cuenta?.cuenta);
      const cb = norm(b?.cuenta?.cuenta);
      if (ca < cb) return -1;
      if (ca > cb) return 1;

      const ga = norm(a?.gasto);
      const gb = norm(b?.gasto);
      if (ga < gb) return -1;
      if (ga > gb) return 1;

      return 0;
    });

    return arr;
  }, [gastos]);

  return (
    <div className="table-container">
      {!gastos.loading && (
        <>
          <div className="col-12 mt-4" />
          <div>
            <Table striped bordered hover className="table-container">
              <thead>
                <tr className="header">
                  <th>Acciones</th>
                  <th>Nro</th>
                  <th className="cli">Cuenta</th>
                  <th className="cli">Gasto</th>
                </tr>
              </thead>

              <tbody>
                {listaOrdenada.map((g) =>
                  g.activo ? (
                    <tr key={g._id}>
                      <td>
                        <button
                          className="btn btn-primary"
                          onClick={() => modificaGasto(g._id)}
                        >
                          <i className="fa fa-pencil-square-o" aria-hidden="true" />
                        </button>
                        <button
                          className="btn btn-danger ml-2"
                          onClick={() => eliminarGasto(g._id)}
                        >
                          <i className="fa fa-trash-o" aria-hidden="true" />
                        </button>
                      </td>
                      <td>{g.codgas}</td>
                      <td>{g?.cuenta?.cuenta || "-"}</td>
                      <td>{g.gasto}</td>
                    </tr>
                  ) : null
                )}
              </tbody>
            </Table>
          </div>

          <ModalGasto show={show} handleClose={handleClose} gasto={gasto} />
        </>
      )}
    </div>
  );
};

export default TableGastos;